import { Box, InputLabel } from '@mui/material';
import { UpdateMeDTOSalutationEnum } from 'probonio-shared-ui/api';
import { TitleAutocompleteControl } from 'probonio-shared-ui/component/autocomplete/TitleAutocompleteControl';
import { SalutationSelectControl } from 'probonio-shared-ui/component/select/SalutationSelectControl';
import React from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SelectControl } from '../../component/form';
import { TextFieldControl } from '../../component/form/TextFieldControl';
import { useLocaleOptions } from '../../component/languageSelect/useLocaleOptions';

export interface MeFields {
  firstName: string;
  lastName: string;
  title: string;
  salutation: UpdateMeDTOSalutationEnum;
  locale: string;
}

interface Props {
  control: Control<MeFields>;
  onSubmit: () => void;
}

// Require at least one unicode letter
const pattern = /\p{L}+/u;

const UserEditForm: React.FC<Props> = ({ onSubmit, control }) => {
  const { t } = useTranslation('navigationModule');
  const { t: tError } = useTranslation('errorModule');

  const localeOptions = useLocaleOptions();

  return (
    <form onSubmit={onSubmit}>
      <Box sx={{ marginBottom: 1 }}>
        <InputLabel variant="standard" htmlFor="salutation" id="salutation-label">
          {t('userEdit.salutation.title')}
        </InputLabel>
        <SalutationSelectControl
          name="salutation"
          id="salutation"
          labelId="salutation-label"
          control={control}
          emptyLabel={t('userEdit.salutation.notSet')}
          getLabel={value => t(`userEdit.salutation.${value}`)}
          errorText={tError('form.required')}
        />
      </Box>
      <Box sx={{ marginBottom: 1 }}>
        <InputLabel variant="standard" htmlFor="title">
          {t('userEdit.title')}
        </InputLabel>
        <TitleAutocompleteControl name="title" id="title" control={control} />
      </Box>
      <Box sx={{ marginBottom: 1 }}>
        <InputLabel variant="standard" htmlFor="firstName" required>
          {t('userEdit.firstName')}
        </InputLabel>
        <TextFieldControl
          control={control}
          rules={{ required: true, pattern }}
          name="firstName"
          id="firstName"
          fullWidth
          variant="outlined"
          margin="dense"
        />
      </Box>
      <Box sx={{ marginBottom: 1 }}>
        <InputLabel variant="standard" htmlFor="lastName" required>
          {t('userEdit.lastName')}
        </InputLabel>
        <TextFieldControl
          control={control}
          rules={{ required: true, pattern }}
          name="lastName"
          id="lastName"
          fullWidth
          variant="outlined"
          margin="dense"
        />
      </Box>
      <Box>
        <InputLabel variant="standard" htmlFor="locale">
          {t('userEdit.locale')}
        </InputLabel>
        <SelectControl control={control} name="locale" id="locale" variant="outlined" margin="dense" fullWidth options={localeOptions} />
      </Box>
    </form>
  );
};

export default UserEditForm;
